module.exports = __webpack_public_path__ + "img/evaluacion-cerrar.0992003c.svg";